module.exports = __webpack_public_path__ + "img/collect002.04850185.jpg";